const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterviewS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.941176%,96.470588%,22.352941%)",
      fillOpacity: 1
    },
    d: "M 36 18 C 36 27.941406 27.941406 36 18 36 C 8.058594 36 0 27.941406 0 18 C 0 8.058594 8.058594 0 18 0 C 27.941406 0 36 8.058594 36 18 Z M 36 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.710938 16.023438 C 23.707031 15.539062 23.316406 15.144531 22.832031 15.144531 L 21.074219 15.144531 L 21.074219 13.386719 C 21.074219 12.902344 20.679688 12.511719 20.195312 12.511719 L 13.167969 12.511719 C 12.683594 12.511719 12.292969 12.902344 12.289062 13.386719 L 12.289062 20.414062 C 12.289062 20.585938 12.386719 20.738281 12.539062 20.8125 C 12.691406 20.886719 12.875 20.863281 13.007812 20.757812 L 14.925781 19.207031 L 14.925781 20.855469 C 14.925781 21.34375 15.320312 21.734375 15.804688 21.734375 L 20.941406 21.734375 L 22.992188 23.394531 C 23.121094 23.5 23.304688 23.523438 23.457031 23.449219 C 23.609375 23.375 23.707031 23.222656 23.707031 23.054688 Z M 21.371094 20.953125 C 21.296875 20.886719 21.199219 20.851562 21.097656 20.851562 L 15.804688 20.851562 L 15.804688 19.097656 L 20.195312 19.097656 C 20.679688 19.097656 21.074219 18.703125 21.074219 18.21875 L 21.074219 16.023438 L 22.832031 16.023438 L 22.832031 22.128906 Z M 21.371094 20.953125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewS);
export default __webpack_public_path__ + "static/media/interview_s.a7c612a18c8395c7cdde5a60b513dc87.svg";
export { ForwardRef as ReactComponent };